import { gql } from "@apollo/client";

export default gql`
  mutation emailMeetingInvitesNewPageMutation(
    $meetingId: Int!
    $recipientEmails: [String]!
    $message: String
  ) {
    emailMeetingInvites(
      meetingId: $meetingId
      recipientEmails: $recipientEmails
      message: $message
    ) {
      meeting {
        id
      }
    }
  }
`;
